<template>
  <div class="main-content">
    <avue-crud
      ref="crud"
      :data="tableData"
      :option="option"
      :table-loading="showLoading"
      :page.sync="page"
      @on-load="onLoad"
    >
      <template #header>
        <div>
          <div class="flex flex-wrap align-items marginBottom20">
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >设备ID :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.deviceId"
                  placeholder="请输入"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >设备名称 :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.name"
                  placeholder="请输入"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >所属用户/ID :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.userId"
                  placeholder="请输入用户名称/ID"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >手机号码 :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.phone"
                  placeholder="请输入"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >所属分组/ID :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.groupId"
                  placeholder="请输入分组名称/ID"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >所属网关/ID :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.gatewayId"
                  placeholder="请输入网关名称/ID"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>

            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >时间 :
              </span>
              <div class="width300">
                <el-date-picker
                  v-model="searchData.createTime"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :clearable="true"
                >
                  <!-- @change="handleSearch" -->
                </el-date-picker>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >消息类型 :
              </span>
              <div class="width300">
                <el-select class="width250" v-model="searchData.type" clearable>
                  <el-option :value="1" label="故障"></el-option>
                  <el-option :value="2" label="报警"></el-option>
                  <el-option :value="3" label="变位"></el-option>
                  <el-option :value="6" label="申请"></el-option>
                  <el-option :value="7" label="维保提醒"></el-option>
                  <el-option :value="8" label="其他"></el-option>
                </el-select>
              </div>
            </div>
            <el-button
              size="medium"
              type="primary"
              @click="handleSearch"
              class="marginLeft10"
              style="margin-bottom: 10px"
              >搜索</el-button
            >
            <el-button
              size="medium"
              type="info"
              @click="handleReset"
              class="marginLeft10 marginRight10"
              style="margin-bottom: 10px"
              >重置</el-button
            >
          </div>
        </div>
      </template>
      <template slot="type" slot-scope="{ row }">
        <div>
          {{
            row.type == 1
              ? "故障"
              : row.type == 2
              ? "报警"
              : row.type == 3
              ? "变位"
              : row.type == 6
              ? "申请"
              : row.type == 7
              ? "维保提醒"
              : row.type == 8
              ? "其他"
              : ""
          }}
        </div>
      </template>
      <template slot="content" slot-scope="{ row }">
        <div>
          {{ row.content + (row.faultParam || "") }}
        </div>
      </template>
    </avue-crud>
  </div>
</template>

<script>
import { remindList } from "@/api/message/remind";
import dayjs from "dayjs";
import FormEditor from "@/components/formComponents/formEditor";
export default {
  name: "index",
  components: {
    FormEditor,
  },
  data() {
    return {
      searchData: {},
      page: {
        total: 0,
        currentPage: 1,
      },
      tableData: [],
      showLoading: false,
      showLoadingForm: false,
      dialogVisible: false,
      selectedRowKeys: [], //表格勾选中的数据
      option: {
        title: "",
        titleSize: "h3",
        card: false,
        border: true,
        header: false,
        stripe: false, // 显示斑马纹
        showHeader: true, // 显示表头
        index: false, // 显示索引
        indexLabel: "序号", // 索引文字
        size: "small",
        page: true, // 显示分页
        align: "center",
        menu: false,
        menuAlign: "center",
        menuType: "text",
        editBtn: false,
        delBtn: false,
        column: [
          {
            label: "设备ID",
            prop: "deviceId",
          },
          {
            label: "设备名称",
            prop: "name",
          },
          {
            label: "所属用户",
            prop: "nickname",
          },
          {
            label: "手机号",
            prop: "phone",
          },
          {
            label: "所属分组",
            prop: "groupName",
          },
          {
            label: "所属网关",
            prop: "gatewayName",
          },
          {
            label: "时间",
            prop: "createTime",
          },
          {
            label: "操作人",
            prop: "operateNickname",
          },
          {
            label: "消息类型",
            prop: "type",
          },
          {
            label: "详情",
            prop: "content",
          },
        ],
      },
      form: {
        id: "",
        // sort: " ",
        title: "",
        details: "",
      },
      formOption: {
        submitBtn: false,
        submitText: "确定",
        emptyBtn: false,
        labelWidth: "100",
        row: true,
        column: [],
      },
    };
  },
  created() {},
  methods: {
    onLoad() {
      this.showLoading = true;
      const searchData = {
        ...this.searchData,
      };
      if (this.searchData.createTime) {
        searchData.createTimeStart = dayjs(
          this.searchData.createTime[0]
        ).format("YYYY-MM-DD 00:00:00");
        searchData.createTimeEnd = dayjs(this.searchData.createTime[1]).format(
          "YYYY-MM-DD 23:59:59"
        );
      }
      delete searchData.createTime;
      remindList({
        page: this.page.currentPage,
        size: this.page.pageSize,
        ...searchData,
      }).then((res) => {
        this.showLoading = false;
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.page.total = res.data.total;
        }
      });
    },

    // 查询
    handleSearch() {
      // console.log('查询')
      this.page.currentPage = 1;
      this.onLoad();
    },
    // 重置
    handleReset() {
      // console.log('重置')
      this.searchData = {
        state: "",
        name: "",
        createTime: "",
      };
      this.page.currentPage = 1;
      this.onLoad();
    },

    // 关闭
    handleClose() {
      this.dialogVisible = false;
      setTimeout(() => {
        // this.resetForm();
      }, 500);
    },
    //编辑
    async handleDetails(row) {
      console.log(row);
      this.dialogVisible = true;
      this.form = { ...row };
    },

    //输入
    salaryDianChange(e, t) {
      const value = e.target.value;
      this.form[t] = value;
    },
  },
};
</script>

<style scoped>
.box_message {
  display: flex;
  justify-content: space-between;
  background: #f2f2f2;
  border-radius: 5px;
  padding: 10px 15px;
}
.box_content {
  margin-top: 15px;
}
</style>
